module.exports = __webpack_public_path__ + "images/maps/locations/map_be93267b6de8879c55d76c479cd5ccb7.png";